module.exports = __webpack_public_path__ + "static/media/art-questions.b15b8595.csv";